import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, forwardRef } from 'react';
import { CardTitle } from './CardTitle';
import { CardWrapper } from './styles';
export const Card = memo(forwardRef(function Card(props, ref) {
    const { title, tooltip, children, id, action, className, height, dataTestId, filter, tag, toggleButton, onToggle } = props;
    return (_jsxs(CardWrapper, { id: id, className: className, height: height, "data-testid": dataTestId, ref: ref, children: [action || title || filter ? (_jsx(CardTitle, { title: title, tooltip: tooltip, action: action, filter: filter, tag: tag, toggleButton: toggleButton, onToggle: onToggle })) : null, children] }));
}));
